import { Button } from "@tellescope/ui";
import { sanitizePortalHTMLContent } from "@tellescope/utils";
import { CheckCircle2 } from "lucide-react";
import { useTranslation } from "react-i18next";

interface EnduserFormWizardThanksScreenProps {
  htmlMessage?: string;
  message?: string;
  onDone: () => void;
}

export const EnduserFormWizardThanksScreen = ({ htmlMessage, message, onDone }: EnduserFormWizardThanksScreenProps) => {
  const { t } = useTranslation("forms");

  return (
    <div className="flex flex-col h-full items-center justify-center p-8 text-center gap-6">
      <CheckCircle2 className="h-12 w-12 text-primary" />
      {htmlMessage ? (
        <div
          className="text-muted-foreground"
          dangerouslySetInnerHTML={{ __html: sanitizePortalHTMLContent(htmlMessage) }}
        />
      ) : (
        <p className="text-muted-foreground">{message ?? t("Thank you for completing this form.")}</p>
      )}
      <Button onClick={onDone}>{t("Done")}</Button>
    </div>
  );
};
